"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = void 0;
var inversify_1 = require("inversify");
var container_1 = require("../ioc/container");
var ApiAdapter_1 = require("./ApiAdapter");
/**
 * Api is a base class for client Api objects.
 *
 * These are wrappers around the endpoints that provide a more convenient interface
 * to the UI, construct the relevant DTO objects and make the corresponding network
 * requests.
 */
var Api = /** @class */ (function () {
    function Api() {
        Object.defineProperty(this, "api", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    Object.defineProperty(Api, "get", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return container_1.getCoreContainer().resolve(this);
        }
    });
    __decorate([
        inversify_1.inject(ApiAdapter_1.ApiAdapter),
        __metadata("design:type", ApiAdapter_1.ApiAdapter)
    ], Api.prototype, "api", void 0);
    Api = __decorate([
        inversify_1.injectable()
    ], Api);
    return Api;
}());
exports.Api = Api;
//# sourceMappingURL=Api.js.map